import { Component, Input } from '@angular/core';

@Component({
    selector: 'rwidget-reset-password-aside',
    templateUrl: './reset-password-aside.component.html',
})
export class ResetPasswordAsideComponent {
    @Input() formerCustomerFirstVisit = false;
}
